// components/landing/NextComponent.tsx
export default function NextComponent() {
  return (
    <div style={{ fontSize: "2rem", textAlign: "center" }}>
      👋 Welcome to the next section!
    </div>
  );
}
